import * as React from 'react'

function SvgIconRouter(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg viewBox="0 0 32 32" width="1em" height="1em" {...props}>
      <g id="router" aria-labelledby="t-router d-router">
        <title id="t-router">{'Router'}</title>
        <desc id="d-router">
          {'A modem has an antenna with waves radiating from it'}
        </desc>
        <circle cx={14} cy={28} r={1} />
        <circle cx={11} cy={28} r={1} />
        <circle cx={8} cy={28} r={1} />
        <path d="M27 24H17l-.4-10.1c.801-.3 1.4-1 1.4-1.9 0-1.1-.9-2-2-2s-2 .9-2 2c0 .9.6 1.7 1.4 1.9L15 24H5c-.6 0-1 .4-1 1v6c0 .6.4 1 1 1h22c.6 0 1-.4 1-1v-6c0-.6-.4-1-1-1zM15 12c0-.6.4-1 1-1s1 .4 1 1-.4 1-1 1-1-.4-1-1zm12 19H5v-6h22v6z" />
        <path d="M26.6 1.4c5.9 5.9 5.9 15.4 0 21.2-.199.2-.199.5 0 .7.2.2.5.2.7 0 6.2-6.2 6.2-16.4 0-22.6-.2-.2-.5-.2-.7 0-.2.2-.2.5 0 .7z" />
        <path d="M23.1 4.9C27 8.8 27 15.1 23.1 19c-.199.2-.199.5 0 .7.2.2.5.2.7 0 4.3-4.3 4.3-11.3 0-15.6-.2-.2-.5-.2-.7 0-.2.3-.2.6 0 .8zM19.5 8.5c2 2 2 5.1 0 7.1-.2.2-.2.5 0 .7.2.2.5.2.7 0 2.3-2.3 2.3-6.1 0-8.5-.2-.2-.5-.2-.7 0-.2.2-.2.5 0 .7zM11.8 7.8c-2.3 2.3-2.3 6.1 0 8.5.2.2.5.2.7 0 .2-.2.2-.5 0-.7-2-2-2-5.1 0-7.1.2-.2.2-.5 0-.7-.2-.2-.5-.2-.7 0zM8.2 19.8c.2.2.5.2.7 0 .2-.2.2-.5 0-.7C5 15.2 5 8.8 8.9 4.9c.2-.2.2-.5 0-.7-.2-.2-.5-.2-.7 0-4.3 4.3-4.3 11.3 0 15.6z" />
        <path d="M4.7.7c-6.2 6.2-6.2 16.399 0 22.6.2.2.5.2.7 0 .2-.2.2-.5 0-.7-5.9-5.9-5.9-15.4 0-21.2.2-.2.2-.5 0-.7-.2-.2-.5-.2-.7 0z" />
      </g>
    </svg>
  )
}

export default SvgIconRouter
